import { useEffect } from 'react'
import { getSafeMessages } from '@safe-global/safe-gateway-typescript-sdk'
import type { SafeMessageListPage } from '@safe-global/safe-gateway-typescript-sdk'

import useAsync from '@/hooks/useAsync'
import { logError, Errors } from '@/services/exceptions'
import useSafeInfo from '@/hooks/useSafeInfo'
import type { AsyncResult } from '@/hooks/useAsync'
import { useCurrentChain } from '../useChains'
import { usesOnChainSafeInfo } from '@/services/safe-info'

const EMPTY_MESSAGE_PAGE: SafeMessageListPage = { results: [] }

export const useLoadSafeMessages = (): AsyncResult<SafeMessageListPage> => {
  const { safe, safeAddress, safeLoaded } = useSafeInfo()
  const chain = useCurrentChain()
  const readOnChain = usesOnChainSafeInfo(chain)

  const [data, error, loading] = useAsync<SafeMessageListPage>(
    () => {
      if (!safeLoaded) return
      if (!safe.deployed || readOnChain) return Promise.resolve(EMPTY_MESSAGE_PAGE)

      return getSafeMessages(safe.chainId, safeAddress)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [safeLoaded, safe.chainId, safeAddress, safe.messagesTag, safe.deployed, readOnChain],
    false,
  )

  useEffect(() => {
    if (error) {
      logError(Errors._608, error.message)
    }
  }, [error])

  return [data, error, loading]
}

export default useLoadSafeMessages
